// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_eC","advertDetailHeaderPrice__value":"c-m_eE","advertDetailHeaderPrice__label":"c-m_eF"};